import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=0ef5d84c&scoped=true&"
import script from "./MessageItem.vue?vue&type=script&lang=js&"
export * from "./MessageItem.vue?vue&type=script&lang=js&"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=0ef5d84c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef5d84c",
  null
  
)

export default component.exports